import { render, staticRenderFns } from "./Flex.vue?vue&type=template&id=66f784ae&scoped=true&"
import script from "./Flex.vue?vue&type=script&lang=ts&"
export * from "./Flex.vue?vue&type=script&lang=ts&"
import style0 from "./Flex.vue?vue&type=style&index=0&id=66f784ae&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66f784ae",
  null
  
)

export default component.exports